import axios from 'axios';
import store from '@/store';
import { baseURL } from "@/helper";
import router from "@/router";

export default (token) => {
	const instance = axios.create({
		baseURL,
		headers: {
			'Content-Type': 'application/json',
			'Authorization': token
		}
	});

	function onFulfilled(config) {
		const token = localStorage.getItem('auth-token');
		if (token) {
			config.headers.Authorization = token;
		} else {
			('Autorization' in config.headers) ? delete config.headers.Authorization : '';
		}

		return config;
	}

	function onRejected(error) {
		if (error.response.status === 401) {
			store.state.isAuth = false;
			localStorage.clear();
			router?.push('/auth').then(() => {});
			store.dispatch("setAlert", { type: "error", message: "You are not authorized" });
		}

		if (error.response.status === 412) {
			store.dispatch("setAlert", { type: "error", message: error.response.data.error.mail });
		}

		if (error.response.status === 404) {
			store.dispatch("setAlert", { type: "error", message: error.response.data.error.mail });
		}

		return error.response;
	}

	instance.interceptors.request.use(onFulfilled, onRejected);
	instance.interceptors.response.use(onFulfilled, onRejected);
	return instance;
};
